<template>
  <footer class="stash-card-footer px-6" data-test="stash-card-footer">
    <!-- @slot Default slot, for rendering any card footer content -->
    <slot></slot>
  </footer>
</template>
